module.exports = __webpack_public_path__ + "56195441817e7172c4cd914388710f20.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceHanSansSC-Regular-2.otf
// module id = 1050
// module chunks = 0